
export enum CommonActionTypes {
	PROCESS_VERIFICATION_RESPONSE = "PROCESS_VERIFICATION_RESPONSE",
	PROCESS_VERIFICATION_RESPONSE_COMPLETE = "PROCESS_VERIFICATION_RESPONSE_COMPLETE",
	SET_CUSTOM_CSS_LOADED = "SET_CUSTOM_CSS_LOADED",
	SET_CUSTOM_FOOTER_HTML = "SET_CUSTOM_FOOTER_HTML",
	SET_CUSTOM_HEADER_HTML = "SET_CUSTOM_HEADER_HTML",
	SET_REDIRECT_URL = "SET_REDIRECT_URL",
	SET_VERIFICATION_MESSAGE = "SET_VERIFICATION_MESSAGE",
	SUBMIT_VERIFICATION_DATA = "SUBMIT_VERIFICATION_DATA",
	SUBMIT_VERIFICATION_DATA_FAILED = "SUBMIT_VERIFICATION_DATA_FAILED",
	SET_ROLLBAR_ENABLED = "SET_ROLLBAR_ENABLED",
    SET_SHOULD_REDIRECT = "SET_SHOULD_REDIRECT",
    SET_SHOULD_UPDATE_SUBMIT_BUTTON = "SET_SHOULD_UPDATE_SUBMIT_BUTTON",
    SET_FORCE_SHOW_APP_VERSION = "SET_FORCE_SHOW_APP_VERSION"
}

type ProcessVerificationResponseAction = {
    type: CommonActionTypes.PROCESS_VERIFICATION_RESPONSE
};

export const processVerificationResponse = (): ProcessVerificationResponseAction => ({
    type: CommonActionTypes.PROCESS_VERIFICATION_RESPONSE
});

type ProcessVerificationResponseCompleteAction = {
    type: CommonActionTypes.PROCESS_VERIFICATION_RESPONSE_COMPLETE;
};

export const processVerificationResponseComplete = (): ProcessVerificationResponseCompleteAction => ({
    type: CommonActionTypes.PROCESS_VERIFICATION_RESPONSE_COMPLETE
});

type SetCustomCssLoadedAction = {
    type: CommonActionTypes.SET_CUSTOM_CSS_LOADED,
    payload: { isCustomCssLoaded: boolean; };
};

export const setCustomCssLoaded = (isCustomCssLoaded: boolean): SetCustomCssLoadedAction => ({
    type: CommonActionTypes.SET_CUSTOM_CSS_LOADED,
    payload: {
        isCustomCssLoaded
    }
});

type SetCustomFooterHtmlAction = {
    type: CommonActionTypes.SET_CUSTOM_FOOTER_HTML,
    payload: { html: string };
};

export const setCustomFooterHtml = (html: string): SetCustomFooterHtmlAction => ({
    type: CommonActionTypes.SET_CUSTOM_FOOTER_HTML,
    payload: {
        html
    }
});

type SetCustomHeaderHtmlAction = {
    type: CommonActionTypes.SET_CUSTOM_HEADER_HTML,
    payload: { html: string };
};

export const setCustomHeaderHtml = (html: string): SetCustomHeaderHtmlAction => ({
    type: CommonActionTypes.SET_CUSTOM_HEADER_HTML,
    payload: {
        html
    }
});

type SetRedirectUrlAction = {
    type: CommonActionTypes.SET_REDIRECT_URL,
    payload: { redirectUrl: string };
};

export const setRedirectUrl = (redirectUrl: string): SetRedirectUrlAction => ({
    type: CommonActionTypes.SET_REDIRECT_URL,
    payload: {
        redirectUrl
    }
});

type SetVerificationMessageAction = {
    type: CommonActionTypes.SET_VERIFICATION_MESSAGE;
    payload: { message: string };
};

export const setVerificationMessage = (message: string): SetVerificationMessageAction => ({
    type: CommonActionTypes.SET_VERIFICATION_MESSAGE,
    payload: { message }
});

type SubmitVerificationDataAction = {
    type: CommonActionTypes.SUBMIT_VERIFICATION_DATA
};

export const submitVerificationData = (): SubmitVerificationDataAction => ({
    type: CommonActionTypes.SUBMIT_VERIFICATION_DATA
});

type SubmitVerificationDataFailedAction = {
    type: CommonActionTypes.SUBMIT_VERIFICATION_DATA_FAILED,
    payload: { message: string };
};

export const submitVerificationDataFailed = (message: string): SubmitVerificationDataFailedAction => ({
    type: CommonActionTypes.SUBMIT_VERIFICATION_DATA_FAILED,
    payload: {
        message
    }
});

type SetRollbarEnabledAction = {
    type: CommonActionTypes.SET_ROLLBAR_ENABLED,
    payload: { enabled: boolean };
};

export const setRollbarEnabled = (enabled: boolean): SetRollbarEnabledAction => ({
    type: CommonActionTypes.SET_ROLLBAR_ENABLED,
    payload: {
        enabled
    }
});

type SetShouldRedirectAction = {
    type: CommonActionTypes.SET_SHOULD_REDIRECT,
    payload: { shouldRedirect: boolean };
};

export const setShouldRedirect = (shouldRedirect: boolean): SetShouldRedirectAction => ({
    type: CommonActionTypes.SET_SHOULD_REDIRECT,
    payload: { shouldRedirect }
});

type SetShouldUpdateSubmitButtonAction = {
    type: CommonActionTypes.SET_SHOULD_UPDATE_SUBMIT_BUTTON,
    payload: { shouldUpdate: boolean }
};

export const setShouldUpdateSubmitButton = (shouldUpdate: boolean): SetShouldUpdateSubmitButtonAction => ({
    type: CommonActionTypes.SET_SHOULD_UPDATE_SUBMIT_BUTTON,
    payload: { shouldUpdate }
});

type SetForceShowAppVersionAction = {
    type: CommonActionTypes.SET_FORCE_SHOW_APP_VERSION;
    payload: { forceShowAppVersion: boolean }
};

export const setForceShowAppVersion = (forceShowAppVersion: boolean): SetForceShowAppVersionAction => ({
    type: CommonActionTypes.SET_FORCE_SHOW_APP_VERSION,
    payload: { forceShowAppVersion}
});

export type CommonActions =
    ProcessVerificationResponseAction |
    ProcessVerificationResponseCompleteAction |
    SetCustomCssLoadedAction |
    SetCustomFooterHtmlAction |
    SetCustomHeaderHtmlAction |
    SetRedirectUrlAction |
    SetVerificationMessageAction |
    SubmitVerificationDataAction |
    SubmitVerificationDataFailedAction |
    SetRollbarEnabledAction |
    SetShouldRedirectAction |
    SetShouldUpdateSubmitButtonAction |
    SetForceShowAppVersionAction